import ApplicationTitle from '../../components/ApplicationTitle';
import TwoInputs from '../../components/input_fields/TwoInputs'
import StackedTitle from '../../components/form_titles/StackedTitle';
import DoubleButton from '../../components/buttons/DoubleButton';
import ThreeInptus from '../../components/input_fields/ThreeInputs';
import HalfText from '../../components/input_fields/halfText';
// import TextSelectInput from '../../components/input_fields/TextSelectInput';
import ProgressBar from '../../components/progress/ProgressBar';

// import validator from "validator";
import React, { useState, useEffect } from "react";

export default function Step5b({ nextStep, nextHalfStep, handleFormData, prevStep, values, color }) {

  // Required
  const [otherStreetError, setOtherStreetError] = useState(false)
  const [otherPhoneError, setOtherPhoneError] = useState(false)
  const [otherEmailError, setOtherEmailError] = useState(false)
  const [otherCityError, setOtherCityError] = useState(false)
  const [otherStateError, setOtherStateError] = useState(false)
  const [otherZipError, setOtherZipError] = useState(false)

  // Not Required
  // const [otherFaxError, setOtherFaxError] = useState(false)
  // const [otherStreet2Error, setOtherStreet2Error] = useState(false)

  const submitFormData = (e) => {
    e.preventDefault();

    // Business Street Error
    // if (validator.isEmpty(values.otherStreet)) {
    //   setOtherStreetError(true)
    //   return
    // } setOtherStreetError(false)

    // // Business Phone Error
    // if (!validator.isMobilePhone(values.otherPhone)) {
    //   setOtherPhoneError(true)
    //     return
    // } setOtherPhoneError(false)

    // // Business Email Error
    // if (!validator.isEmail(values.otherEmail)) {
    //   setOtherEmailError(true)
    //   return
    // } setOtherEmailError(false)

    // // Business City Error
    // if (validator.isEmpty(values.otherCity)) {
    //   setOtherCityError(true)
    //   return
    // } setOtherCityError(false)

    // // Business State Error
    // if (!data.states.includes(values.otherState)) {
    //   setOtherStateError(true)
    //   return
    // } setOtherStateError(false)

    // // Business Zipcode Error
    // if (!validator.isNumeric(values.otherZip) || values.otherZip.length !== 5) {
    //   setOtherZipError(true)
    //   return
    // } setOtherZipError(false)

    nextHalfStep()
  }

  useEffect(() => {
    setOtherStreetError(false);
    setOtherPhoneError(false);
    setOtherEmailError(false);
    setOtherCityError(false);
    setOtherStateError(false);
    setOtherZipError(false);
  }, []);

  return (
    <div className="bg-white-900 dark:bg-white-900">
      <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
        <ApplicationTitle
          mainTitle="Bipsypay Merchant Application"
          subTitle="Complete the form below to begin your Bipsypay merchant application"
        />
        <ProgressBar
          progress="66%"
          color={color}
        />
        <div className="bg-white rounded-lg shadow dark:border width-screen xl:p-0">
          <div className="p-6 space-y-1 sm:p-8">
            <StackedTitle
              color={color}
              mainTitle="Share your"
              colorTitle="business location."
              subText="Enter the physical address of the business location (NO PO Box)"
              modalTitle="Why do you need this..."
              modalDesc="The Card Brands (Visa/ MasterCard) rules require merchants to submit complete data, including name, type of business, and merchant location with each transaction. Providing the proper information is important for: Cardholder recognition, and reducing unnecessary cardholder disputes, Accurate risk assessment and authorization decisions, reducing additional risk to all participants in the Visa system Accurate assessment of fees and interchange."
            />
            <form className="space-y-4" onSubmit={submitFormData}>
              <TwoInputs
                color={color}
                placeholder1="Street Address" id1="stree_add" name1="otherStreet" type1="text"
                error1={otherStreetError} message1={"Please provide a street address."}
                handleInputChange1={handleFormData}
                placeholder2="Phone Number (123) 456-7890" id2="busPhone" name2="otherPhone" type2="text"
                error2={otherPhoneError} message2={"Please enter a valid phone number."}
                handleInputChange2={handleFormData}
              />
              <TwoInputs
                color={color}
                placeholder1="Street Address Line 2" id1="address2" name1="otherStreet2" type1="text"
                handleInputChange1={handleFormData}
                placeholder2="Business Email Address" id2="email" name2="otherEmail" type2="email"
                error2={otherEmailError} message2={"Please enter a valid email address."}
                handleInputChange2={handleFormData}
              />

              <ThreeInptus
                color={color}
                placeholder1="City" id1="city" type1="text" name1="otherCity"
                error1={otherCityError} message1={"Please enter a city."}
                handleInputChange1={handleFormData}
                placeholder2="State" id2="state" type2="text" name2="otherState"
                error2={otherStateError} message2={"Please enter a valid State."}
                handleInputChange2={handleFormData}
                placeholder3="Fax Number (123) 456-7890" id3="fax" type3="text" name3="otherFax" handleInputChange3={handleFormData}
              />

              <HalfText
                color={color}
                placeholder="Zipcode" id="bus_zip" type="Text" name="otherZip"
                error={otherZipError} message={"Please provide your 5 digit zipcode."}
                handleInputChange={handleFormData}
              />

              <DoubleButton color={color} prevStep={prevStep} />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}